import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { BackToWorkspace } from "../Sections/BackToWorkspace";
import { Support } from "../Sections/Support";
import { setTrackingId } from "client/Misc/utils";

export type NotFoundProps = {
	customHtml: string | nil;
	supportTelephoneNumber: string | nil;
	supportEmailAddress: string | nil;
};

export const NotFound = (props: NotFoundProps): ReactElement => {
	const {
		customHtml,
		supportTelephoneNumber,
		supportEmailAddress
	} = props;

	return (
		<>
			<h2
				{...setTrackingId("error-code|404")}
			>
				{localize("_Error404")}
			</h2>
			<BackToWorkspace />
			<Support
				customHtml={customHtml}
				supportTelephoneNumber={supportTelephoneNumber}
				supportEmailAddress={supportEmailAddress}
				emailSubjectTextTemplate="_Error404"
			/>
		</>
	);
};
NotFound.displayName = "NotFound";